import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { last } from 'lodash';
import { environment } from '../environments/environment';
import { AppConfigService } from './app-config/app-config.service';

@Component({
    selector: 'app-admin-login-page',
    template: `
    <iframe class="vh-100 vw-100"
            #loginIframe
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"></iframe>`,
    standalone: false
})

export class AdminLoginComponent implements AfterViewInit {
  @ViewChild('loginIframe') loginIframe!: ElementRef<HTMLIFrameElement>;

  constructor(private readonly appConfigService: AppConfigService,
    private readonly router: Router) {
  }

  ngAfterViewInit() {
    if (!environment.appAdminLoginUrl) {
      this.router.navigate(['/']);
      return;
    }

    // Check iframe url on each load event and if the url contains the config string, extract it and use it in our app
    if (environment.runAsStandaloneApplication) {
      window.addEventListener('message', (event) => {
        if (event.origin === 'https://pos-4.versacommerce.de') {
          this.appConfigService.storeAppConfig(event.data);
          location.href = '/';
        }
        return false;
      }, false);
    } else {
      this.loginIframe.nativeElement.addEventListener('load', (e: any) => {
        try {
          const url: string = e.currentTarget?.contentWindow?.location.href;
          if (!url || !url.includes('/config/')) {
            return;
          }

          const configStr = last(url.split('/config/'));
          if (!configStr) {
            return;
          }

          this.appConfigService.storeAppConfig(configStr);
          location.href = '/';
        } catch (error) {
          console.warn(error);
        }
      });
    }

    // Set the iframe source to external login url
    this.loginIframe.nativeElement.src = environment.appAdminLoginUrl;
  }
}
